import {
  StorageApi,
  DeleteFileBodyDTO,
  StorageApiStorageGetAllEntityFilesByIdRequest,
  // eslint-disable-next-line no-unused-vars
  StorageApiStorageUploadDocumentsRequest,
  UpdateFileDTO,
  TechnicianTaskManagementApi,
  DeleteFilesBodyDTO
} from '../api-client/generated/api';

const apiCaller = new StorageApi();
const technicianTaskManagementApi = new TechnicianTaskManagementApi();

const deleteFile = async (params: DeleteFileBodyDTO) => {
  if (!params) {
    return null;
  }
  const { status, statusText } = await apiCaller.storageDeleteFile({
    deleteFileBodyDTO: params
  });

  return { status, statusText };
};

const deleteFiles = async (params: DeleteFilesBodyDTO) => {
  if (!params) {
    return null;
  }

  const { status, statusText } = await apiCaller.storageDeleteFiles({
    deleteFilesBodyDTO: params
  });

  return { status, statusText };
};

const uploadCompanyLogo = async (params: any) => {
  if (!params) {
    return null;
  }
  const { file } = params;
  const { status, statusText } = await apiCaller.storageUploadCompanyLogo({
    file
  });

  return { status, statusText };
};

const uploadProfilePhoto = async (params: any) => {
  if (!params) {
    return null;
  }
  const { file } = params;
  const { status, statusText } = await apiCaller.storageUploadUserPhoto({
    file
  });

  return { status, statusText };
};

const getProfilePhoto = async () => {
  const data = await apiCaller.storageGetProfilePhotos();
  return data;
};

const getProfilePhotoByID = async (params: any) => {
  const { id } = params;
  const data = await apiCaller.storageGetProfilePhotosFromProfile({ id });
  return data as any;
};

const getProfilePhotoByIDS = async (params: { users: any }) => {
  const { users } = params;
  const promises = users.map(async (item: any) => {
    try {
      const data: any = await apiCaller.storageGetProfilePhotosFromProfile({
        id: item?.id
      });
      return { photo: data?.data[1]?.fileUrl, user: item };
    } catch (error) {
      return { photo: null, user: item };
    }
  });

  const results = await Promise.allSettled(promises);
  return results.map((result) => {
    if (result.status === 'fulfilled') {
      return result.value;
    }
    return { photo: null, user: result };
  });
};

const getCopmanyLogo = async () => {
  const data = await apiCaller.storageGetCompanyLogo();

  return data;
};

const getEntityFiles = async (
  params: StorageApiStorageGetAllEntityFilesByIdRequest
) => {
  if (!params) {
    return null;
  }

  const data = await apiCaller.storageGetAllEntityFilesById(params);

  return data;
};

const uploadCompanyBrochure = async (params: any) => {
  if (!params) {
    return null;
  }
  const { file } = params;
  const { status, statusText } = await apiCaller.storageUploadCompanyBrouchure({
    file
  });

  return { status, statusText };
};

const uploadCompanyTerms = async (params: any) => {
  if (!params) {
    return null;
  }
  const { files } = params;
  const result = (await apiCaller.storageUploadCompanyTerms({
    files
  } as any)) as any;

  const { data, status, statusText } = result;
  return { data, status, statusText };
};

const uploadCompanyClientOnboardingImages = async (params: any) => {
  if (!params) {
    return null;
  }
  const { files } = params;
  const result = await apiCaller.storageUploadClientOnboardingImages({
    files: [files]
  });

  const { data, status, statusText } = result;
  return { data, status, statusText };
};

const uploadEntityFiles = async (params: any) => {
  if (!params || !params?.entityId) {
    return null;
  }
  if (params?.initialLeadFiles && params?.initialLeadFiles.length > 0) {
    await apiCaller.storageDeleteFiles({
      deleteFilesBodyDTO: { fileIds: params?.initialLeadFiles }
    });
  }
  const { files, relatedEntity, entityId } = params as any;
  const result: any = await apiCaller.storageUploadDocuments({
    entityId,
    files,
    relatedEntity
  });

  const { data, status, statusText } = result;
  return { data, status, statusText };
};

const updateEntityFiles = async (params: UpdateFileDTO) => {
  if (!params) {
    return null;
  }

  const { status, statusText } = await apiCaller.storageUpdateFile({
    updateFileDTO: params
  });

  return { status, statusText };
};

const uploadTaskFiles = async (params: any) => {
  if (!params) {
    return null;
  }

  const { files, entityId } = params as any;
  const response = await apiCaller.storageUploadTaskDocuments({
    files,
    taskId: entityId
  });

  return response;
};

const uploadTaskIterationFile = async (params: any) => {
  if (!params) {
    return null;
  }

  const { file, taskId, onProgress } = params as any;

  // Si es un array de archivos, subirlos secuencialmente para evitar problemas de timing
  const files = Array.isArray(file) ? file : [file];
  const uploadResults: any[] = [];
  const errors: any[] = [];
  const totalFiles = files.length;

  // Subir archivos secuencialmente usando reduce
  await files.reduce(async (previousPromise, singleFile, index) => {
    await previousPromise;

    try {
      // Notificar progreso antes de subir
      if (onProgress) {
        onProgress(index, totalFiles);
      }

      const { status, statusText, data } =
        (await apiCaller.storageUploadTaskIterationFile({
          file: singleFile,
          taskId
        } as any)) as any;

      if (data) {
        uploadResults.push({ data, status, statusText });
      }

      // Delay de 500ms entre cada upload (excepto después del último)
      if (index < totalFiles - 1) {
        await new Promise<void>((resolve) => {
          setTimeout(() => resolve(), 500);
        });
      }
    } catch (error) {
      // Capturar errores pero continuar con los demás archivos
      errors.push({ error, file: singleFile.name });
    }

    return Promise.resolve();
  }, Promise.resolve());

  // Notificar que se completó
  if (onProgress) {
    onProgress(totalFiles, totalFiles);
  }

  // Obtener la lista actualizada de archivos después de subir todos
  if (params?.setTaskItearationFilesList) {
    const response =
      await technicianTaskManagementApi.technicianTaskManagenmentGetTaskIterationById(
        { taskIterationId: taskId }
      );
    const { data: data2 } = response;
    const auxData2: any = typeof data2 === 'object' ? data2 : null;

    params?.setTaskItearationFilesList(auxData2?.fileBank);

    return null;
  }

  // Retornar todos los resultados exitosos
  const combinedData = uploadResults
    .flatMap((result) => result.data)
    .filter(Boolean);

  return {
    data: combinedData,
    errors: errors.length > 0 ? errors : undefined,
    status: uploadResults[0]?.status || 200,
    statusText: uploadResults[0]?.statusText || 'OK',
    totalCount: files.length,
    uploadedCount: uploadResults.length
  };
};
const uploadContract = async (params: any) => {
  if (!params) {
    return null;
  }
  const { files, entityId, relatedEntity } = params;
  const { status, statusText, data } = (await apiCaller.storageUploadContract({
    entityId,
    files,
    relatedEntity
  })) as any;

  return { data, status, statusText };
};

const getTaskDetailFiles = async (params: any) => {
  if (!params) {
    return null;
  }
  const { taskId } = params;

  const response = await apiCaller.storageGetTaskDetailFiles({ taskId });
  return response.data;
};

const getClientOnboardingImages = async (params: any) => {
  const response = await apiCaller.storageReturnClientOnboardingImages();
  return response.data;
};

const getContractHeader = async () => {
  const response = await apiCaller.storageGetContractHeader();
  return response.data;
};

const getTermsAndConditions = async (params: any) => {
  if (!params?.id) {
    return null;
  }
  const { id } = params;
  const response = await apiCaller.storageGetTermsAndConditions({ id });
  return response.data;
};

const updateContractHeader = async (params: any) => {
  if (!params) {
    return null;
  }
  const { files, entityId, relatedEntity } = params;
  const { status, statusText, data } =
    (await apiCaller.storageUpdateContractHeader({
      entityId,
      files,
      relatedEntity
    })) as any;

  return { data, status, statusText };
};

const updateTermsAndConditions = async (params: any) => {
  if (!params) {
    return null;
  }
  const { files, entityId, relatedEntity } = params;
  const { status, statusText, data } =
    (await apiCaller.storageUpdateTermsAndConditions({
      entityId,
      files,
      relatedEntity
    })) as any;

  return { data, status, statusText };
};

export default {
  deleteFile,
  deleteFiles,
  getClientOnboardingImages,
  getContractHeader,
  getCopmanyLogo,
  getEntityFiles,
  getProfilePhoto,
  getProfilePhotoByID,
  getProfilePhotoByIDS,
  getTaskDetailFiles,
  getTermsAndConditions,
  updateContractHeader,
  updateEntityFiles,
  updateTermsAndConditions,
  uploadCompanyBrochure,
  uploadCompanyClientOnboardingImages,
  uploadCompanyLogo,
  uploadCompanyTerms,
  uploadContract,
  uploadEntityFiles,
  uploadProfilePhoto,
  uploadTaskFiles,
  uploadTaskIterationFile
};
